import { ActionTypes } from 'utils/constants';

export const pricing = (state = {}, action) => {
    switch(action.type) {
        case ActionTypes.FETCH_PRICING + '_PENDING': {
            return {
                ...state,
                fetching: true
            };
        }
        case ActionTypes.FETCH_PRICING + '_FULFILLED': {
            const prices = action.payload.data;

            return {
                ...state,
                fetching: false,
                fetched: true,
                prices
            };
        }
        case ActionTypes.FETCH_PRICING + '_REJECTED': {
            return {
                ...state,
                fetching: false,
                fetched: true,
                error: true
            };
        }
        default: {
            return state;
        }
    }
};
